module.exports = __webpack_public_path__ + "static/media/9DESA18.92a77be3.jpg";